import { render } from "./app-link.vue?vue&type=template&id=37f6707c"
import script from "./app-link.vue?vue&type=script&lang=js"
export * from "./app-link.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/link/app-link.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37f6707c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37f6707c', __exports__)) {
    console.log('reload')
    api.reload('37f6707c', __exports__)
  }
  
  module.hot.accept("./app-link.vue?vue&type=template&id=37f6707c", () => {
    console.log('re-render')
    api.rerender('37f6707c', render)
  })

}


export default __exports__